export default "19ab41686be65a09.svg"